<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import DehumidifierMode from './DehumidifierMode.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	let mode: string;
	const _device = device;
	$: enable = statuses.find((i) => /^(enable)$/.test(i.role));
</script>

<div class="flex-full-height justify-content-end">
	<DehumidifierMode {device} {statuses} bind:mode />
	<ControlsContainer class="mt-s">
		<svelte:fragment slot="first">
			<VirtualBooleanButton
				isWide
				device={_device}
				componentID={enable?.id}
				value={enable?.event}
			/>
			<Text styleType="controls-large" class="mt-s text-bold"
				>{capFirstChar(
					enable?.event
						? $format('label_action_turn_off', { default: 'turn off' })
						: $format('label_action_turn_on', { default: 'turn on' }),
				)}</Text
			>
		</svelte:fragment>
	</ControlsContainer>
</div>
